import React from "react";
import Gradient from "../Gradient";
import SolarIcon from "../../assets/images/solar_light.svg";
import CoffeeCup from "../../assets/images/coffee-cup.png";
import { useTranslation } from "react-i18next";
import CalendlyCustomButton from "../CalendlyCustomButton";

const PriceSection = ({ data, anchorId }) => {
  const { t } = useTranslation();
  if (!data) return null;

  const { title, subTitle, description, hint, priceListField } = data;

  return (
    <section className="section price-section flex-wrapper" id={anchorId}>
      <div className="flex-container section-container">
        <div className="section-header">
          <span className="subTitle">{subTitle}</span>
          <h2>{title}</h2>
          <p className="price-section__description">{description}</p>
        </div>
        <div className="price-section__main">
          {priceListField.map((item, index) => {
            return (
              <div key={item.id} className="price-item">
                <span className="price-item__index">0{index + 1}</span>
                <h3 className="price-item__name">{item.name}</h3>

                {item.PriceListItem.map((priceListItem) => {
                  return (
                    <ul key={priceListItem.id} className="price-item__list">
                      <li className="price-item__list-item">
                        {priceListItem.fieldTitle}
                      </li>
                    </ul>
                  );
                })}
                <span className="price-item__price">
                  {t("price.from")} {item.price}
                </span>
              </div>
            );
          })}
          <img
            className="price-section__main-img"
            src={CoffeeCup}
            alt="coffee"
          />
        </div>
        <div className="price-section__footer">
          <div className="price-section__footer-hint">
            <img src={SolarIcon} alt="solar icon" />
            <span className="price-section__footer-hint__text">{hint}</span>
          </div>
          <div className="price-section__footer-button">
            <CalendlyCustomButton />
          </div>
        </div>
      </div>
      <Gradient
        imageName="gradient9"
        className="gradientFloat"
        bottom="-300px"
        left="-60px"
        width="800px"
        height="800px"
      />
    </section>
  );
};

export default PriceSection;
